import {forEachNode, ready} from '@/shared'
import {renderCarousel} from '@/modules/carousel'

const DistanceToLoad = 0
const CarouselElementSelector = '.js-home-carousel'

function getCarouselOptions () {
  return {
    loop: true,
    lazyload: true,
    autoplay: false,
    autoplayTimeout: 7000,
    nav: true
  }
}

ready(function () {
  const carouselNodes = document.querySelectorAll(CarouselElementSelector)
  forEachNode(carouselNodes, carouselElement => renderCarousel(carouselElement, {
    carouselOptions: getCarouselOptions(),
    distanceToLoad: DistanceToLoad
  }))
})



// WEBPACK FOOTER //
// ./src/home-carousel.js